// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"144":"5d7be593","221":"57b40216","239":"69e74dde","358":"3ee7e952","455":"10b9e751","604":"2da7bfd4","964":"ba2df0a1","977":"8e9cb33b"}[chunkId] + ".chunk.js";
};